import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { ComposicaoEquipe } from '../models/composicao-equipe.model';
import { Page } from '../models/page.model';

@Injectable({
    providedIn: 'root'
})
export class ComposicaoEquipeService extends BaseService<ComposicaoEquipe> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/ComposicaoEquipe`, injector);
    }

    getEquipeByEstimativaId(estimativaId: number): Observable<Page<ComposicaoEquipe>> {
        return this.http.get<Page<ComposicaoEquipe>>(`${environment.API_PRICE}/ComposicaoEquipe/getEquipeByEstimativaId/${estimativaId}`);
    }

    getByEstimativaId(estimativaId: number): Observable<Page<ComposicaoEquipe>> {
        return this.http.get<Page<ComposicaoEquipe>>(`${environment.API_PRICE}/ComposicaoEquipe/GetByEstimativaId/${estimativaId}`);
    }
}